import {
	useFetchChecklist,
	useFetchChecklistStepStatuses,
	useFetchCommentsByChecklistId,
} from "@/components/Procedures/API/ChecklistQueries";

import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";

import { useFetchSuggestionsByChecklistId } from "@/service/ProcedureQueries";

export const useGetChecklistWithLiveData = (
	checklistId: number,
	procedureId: number,
) => {
	const { isLoading: isLoadingChecklist, data: checklist } =
		useFetchChecklist(checklistId);
	const { isLoading: isLoadingStepStatuses, data: statuses } =
		useFetchChecklistStepStatuses(checklist?.ChecklistId, procedureId);

	const { isLoading: isLoadingComments, data: comments } =
		useFetchCommentsByChecklistId(checklistId);

	const { isLoading: isLoadingSuggestions, data: suggestions } =
		useFetchSuggestionsByChecklistId(checklist?.ChecklistId);

	if (
		isLoadingChecklist ||
		isLoadingStepStatuses ||
		isLoadingComments ||
		isLoadingSuggestions
	) {
		return { enrichedChecklist: undefined, isLoading: true };
	}

	// Create enriched steps array
	const enrichedSteps =
		checklist?.Steps?.map((step) => {
			const stepComments = comments?.[step?.Id] ?? [];

			const stepSuggestions = Array.isArray(suggestions)
				? suggestions.filter((s) => s.StepId === step.Id)
				: [];

			const status = Array.isArray(statuses)
				? statuses.find((x) => x.Id === step.Id)
				: undefined;

			const enrichedListenerTags = step.ListenerTags.map((tag) => {
				tag.CurrentValue = status?.ListenerTags.find(
					(tagValue) => tag.Tag === tagValue.LiveTag,
				)?.CurrentValue;
				tag.SavedTagValue = status?.ListenerTags.find(
					(tagValue) => tag.Tag === tagValue.LiveTag,
				)?.SavedTagValue;

				return tag;
			});

			// keep fetched data immutable; build an enriched copy
			const enrichedStep: ProcedureNodeStep = {
				...step,
				Status: status?.Status ? 1 : 0,
				Comments: stepComments,
				ProcedureUpdateSuggestions: stepSuggestions,
				IsSkipped: status?.IsSkipped,
				IsOverridden: status?.IsOverridden,
				ListenerTags: enrichedListenerTags,
			};

			return enrichedStep;
		}) ?? [];

	// Create enriched checklist with all enriched steps
	const enrichedChecklist = checklist
		? {
				...checklist,
				Steps: enrichedSteps,
			}
		: undefined;

	return { data: enrichedChecklist, isLoading: false };
};
